export class FocusManager {

    private focused: HTMLElement;
    private static instanceManager: FocusManager = new FocusManager();

    private constructor() {
        document.addEventListener("focusin", (event) => {
            if (event.target !== document) {
                this.focused = event.target as HTMLElement;
            }
        });
    }

    public getLastFocused() {
        return this.focused;
    }

    public static instance() {
        return this.instanceManager;
    }

    private static getFocusables(element: HTMLElement | Document = document): HTMLElement[] {
        var focussableElements = 'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"]),[data-s6-focusable=true]';

        var focussable = Array.prototype.filter.call(
            element.querySelectorAll(focussableElements),
            function (el) {
                // if element is disabled or is has not container parent or has tabindex = -1, it is not focussable
                if (el.hasAttribute("disabled") || ((el as HTMLElement).offsetParent == null) || (el.hasAttribute('tabindex') && el.tabIndex === -1)) {
                    return false;
                }
                return true;
            }) as HTMLElement[];

        return focussable;
    }

    public static focusNext(target: HTMLElement | Document = document) {
        let focusables = FocusManager.getFocusables(target);
        let index = focusables.indexOf(document.activeElement as HTMLElement) + 1;
        if (index > focusables.length) {
            focusables[0].focus();
        } else {
            focusables[index].focus();
        }
    }

    public static focusPrevious(target: HTMLElement | Document = document) {
        let focusables = FocusManager.getFocusables(target);
        let index = focusables.indexOf(document.activeElement as HTMLElement) - 1;
        if (index < 0) {
            focusables[0].focus();
        } else {
            focusables[index].focus();
        }
    }
}
